import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AddBookForm from './components/AddBookForm';
import BookList from './components/BookList';
import BookGraph from './components/BookGraph';
import Login from './components/Login';
import Register from './components/Register';
import HomePage from './components/HomePage';
import ArtList from './components/ArtList';
import AddArtForm from './components/AddArtForm';
import Cart from './components/Cart';
import PaymentForm from './components/PaymentForm';
import DownloadPage from './components/DownloadPage';
import Founder from './components/Founder'; 
import Login1 from "./components/login_component"; 
import SignUp from "./components/signup_component";
import PaymentManagement from './components/PaymentManagement'; 
import SecurePdfViewer from './components/SecurePdfViewer'; 
import UnderConstruction from './components/UnderConstruction';

import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import ResetAuthorPassword from "./components/reset_author_password";

import ContactForm from './components/ContactForm';
import AdminWithdrawals from './components/AdminWithdrawals';
import AdminVATDashboard from './components/AdminVATDashboard';

import './App.css';
import logo from './images/logo.png';

function App() { 
  return (
    <Router>
      <div className="App">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <h1>PAN AFRICAN BOOK EXCHANGE</h1>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ebooks" element={<BookList />} />
          <Route path="/arts" element={<ArtList />} />
          <Route path="/add-book" element={<AddBookForm />} />
          <Route path="/add-arts" element={<AddArtForm />} />
          <Route path="/graph/:id" element={<BookGraph />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<Login1 />} /> 
          <Route path="/registerAdmin" element={<SignUp />} /> 
          <Route path="/payment-form" element={<PaymentForm />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/SecurePdfViewer" element={<SecurePdfViewer />} /> 
          <Route path="/founder" element={<Founder />} /> 
          <Route path="/payment-management" element={<PaymentManagement />} /> 
          <Route path="/under-construction" element={<UnderConstruction />} />

          {/* Regular User Password Reset Routes */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Author/Admin Password Reset Routes */}
          <Route path="/resetpassword/:token" element={<ResetAuthorPassword />} />
          <Route path="/reset-author-password/:token" element={<ResetAuthorPassword />} />
          <Route path="/reset-author-password" element={<ResetAuthorPassword />} />

          <Route path="/contact" element={<ContactForm />} />
          <Route path="/admin-withdrawals" element={<AdminWithdrawals />} />
          <Route path="/admin-vat-dashboard" element={<AdminVATDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;